module.exports = __webpack_public_path__ + "media/images/icon-folder-6f1dfe40bc3aa36504e16450bc4ad376.svg";